invHdApp.controller('NewOrderController',
    ['$scope', '$location', '$rootScope', 'User', '$timeout', 'Order', 'CustomerOrder', 'FileUploader', '$filter', '$http', '$routeParams',
        function ($scope, $location, $rootScope, User, $timeout, Order, CustomerOrder, FileUploader, $filter, $http, $routeParams) {
            $rootScope.proccesCount = 1;

            // Helper function for robust string comparison for Turkish characters
            function normalizeTurkishString(str) {
                if (typeof str !== 'string') return '';
                return str.trim().toLocaleUpperCase('tr-TR');
            }
            
            // Helper function to refresh both Bootstrap Selectpickers AND normal Angular selects
            function refreshPickers() {
                // Use $timeout to ensure Angular digest cycle is complete
                // This guarantees UI sync for both normal selects and selectpickers
                $timeout(function() {
                    // Angular will automatically run a digest after this timeout
                    // No need for manual $apply()
                    
                    // Also refresh Bootstrap Selectpickers
                    $('.selectpicker').selectpicker('render');
                    $('.selectpicker').selectpicker('refresh');
                }, 0); // 0ms is enough - just needs to be after current digest
            }

            $scope.newOrderData = {
                type: 1,
                address: {},
                scheduled_time: '',
                send_sms_sender: true,
                send_sms_receiver: true,
                print_barcode: true,
                status: 2,
                location: {
                    receiver_type: 'corporate'
                },
                order_payment: 'offline',
                receiver_type: 'corporate',
                flexible_date: 0,
                collection_amount: 0,
                items: [{
                    weight: null,
                }]
            };

            $scope.startMarker = null;
            $scope.endMarker = null;

            var componentForm = {
                street_number: 'short_name',
                route: 'long_name',
                locality: 'long_name',
                administrative_area_level_1: 'short_name',
                administrative_area_level_2: 'short_name',
                country: 'long_name',
                postal_code: 'short_name'
            };

            var mapping = {
                street_number: 'number',
                route: 'street',
                locality: 'city',
                administrative_area_level_1: 'state',
                administrative_area_level_2: 'district',
                country: 'country',
                postal_code: 'zip'
            };

            $scope.imageRotation = 0;
            $scope.zoomLevel = 1;
            $scope.translateX = 0;
            $scope.translateY = 0;
            $scope.isPanning = false;
            $scope.isInitialOrderLoad = false; // Harita olaylarının ilk yüklemede tetiklenmesini önler
            $scope.minZoom = 0.5;
            $scope.maxZoom = 3;
            $scope.zoomStep = 0.1;

            function getImageElement() {
                return document.querySelector('.zoomable-image');
            }

            function limitPan(x, y) {
                const img = getImageElement();
                if (!img) return { x, y };

                const rect = img.getBoundingClientRect();
                const container = img.parentElement.getBoundingClientRect();
                
                // Resmin sınırlarını kontrol et
                const maxX = (rect.width * $scope.zoomLevel - container.width) / 2;
                const maxY = (rect.height * $scope.zoomLevel - container.height) / 2;
                
                return {
                    x: Math.min(Math.max(x, -maxX), maxX),
                    y: Math.min(Math.max(y, -maxY), maxY)
                };
            }

            function updateTransform() {
                const img = getImageElement();
                if (img) {
                    // Zoom seviyesini sınırla
                    $scope.zoomLevel = Math.min(Math.max($scope.zoomLevel, $scope.minZoom), $scope.maxZoom);
                    
                    // Pan pozisyonunu sınırla
                    const limitedPos = limitPan($scope.translateX, $scope.translateY);
                    $scope.translateX = limitedPos.x;
                    $scope.translateY = limitedPos.y;
                    
                    // Transform'u uygula
                    img.style.transform = `translate(${$scope.translateX}px, ${$scope.translateY}px) rotate(${$scope.imageRotation}deg) scale(${$scope.zoomLevel})`;
                }
            }

            function zoomToPoint(scale, pointX, pointY) {
                const img = getImageElement();
                if (!img) return;

                const rect = img.getBoundingClientRect();
                const prevZoom = $scope.zoomLevel;
                
                // Yeni zoom seviyesini hesapla
                $scope.zoomLevel = Math.min(Math.max($scope.zoomLevel * scale, $scope.minZoom), $scope.maxZoom);
                
                // Eğer zoom değişmediyse işlemi sonlandır
                if (prevZoom === $scope.zoomLevel) return;
                
                // Mouse pozisyonuna göre pan ayarla
                const scaleChange = $scope.zoomLevel / prevZoom;
                const imgCenterX = rect.left + rect.width / 2;
                const imgCenterY = rect.top + rect.height / 2;
                
                const distX = pointX - imgCenterX;
                const distY = pointY - imgCenterY;
                
                $scope.translateX = $scope.translateX + (distX * (scaleChange - 1));
                $scope.translateY = $scope.translateY + (distY * (scaleChange - 1));
                
                updateTransform();
            }

            $scope.zoomIn = function() {
                const img = getImageElement();
                if (!img) return;

                const rect = img.getBoundingClientRect();
                zoomToPoint(1.1, rect.left + rect.width / 2, rect.top + rect.height / 2);
            };

            $scope.zoomOut = function() {
                const img = getImageElement();
                if (!img) return;

                const rect = img.getBoundingClientRect();
                zoomToPoint(0.9, rect.left + rect.width / 2, rect.top + rect.height / 2);
            };

            $scope.handleWheel = function(event) {
                event.preventDefault();
                
                const scale = event.deltaY < 0 ? 1.1 : 0.9;
                zoomToPoint(scale, event.clientX, event.clientY);

                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            };

            $scope.startPan = function(event) {
                event.preventDefault();
                const img = getImageElement();
                if (!img) return;

                $scope.isPanning = true;
                
                // Mouse'un başlangıç pozisyonunu kaydet
                $scope.lastX = event.clientX;
                $scope.lastY = event.clientY;
                
                // Resmin başlangıç pozisyonunu kaydet
                $scope.startTranslateX = $scope.translateX;
                $scope.startTranslateY = $scope.translateY;
            };

            $scope.pan = function(event) {
                if (!$scope.isPanning) return;
                event.preventDefault();

                // Mouse'un hareket mesafesini hesapla
                const deltaX = event.clientX - $scope.lastX;
                const deltaY = event.clientY - $scope.lastY;

                // Yeni pozisyonu hesapla ve sınırla
                const newPos = limitPan(
                    $scope.startTranslateX + deltaX,
                    $scope.startTranslateY + deltaY
                );
                
                $scope.translateX = newPos.x;
                $scope.translateY = newPos.y;
                
                updateTransform();
            };

            $scope.stopPan = function() {
                $scope.isPanning = false;
            };

            $scope.resetImage = function() {
                $scope.zoomLevel = 1;
                $scope.translateX = 0;
                $scope.translateY = 0;
                $scope.imageRotation = 0;
                updateTransform();
            };

            $scope.rotateImage = function(degrees) {
                $scope.imageRotation = ($scope.imageRotation + degrees) % 360;
                updateTransform();
            };

            // Mobile source'da müşteri listesi gerektiğinde yükle
            $scope.loadCustomersIfNeeded = function() {
                if ($scope.newOrderData && $scope.newOrderData.source === 'mobile' && 
                    (!$scope.orderData.customers || $scope.orderData.customers.length === 0)) {
                    Filter.getCustomers().success(function(data) {
                        $scope.orderData.customers = data.customers;
                    });
                }
            };

            // Company ID 87 ve 12 için kullanıcının bağlı olduğu şubeyi otomatik seç
            if ($scope.authenticatedUser && ($scope.authenticatedUser.company_id == 87 || $scope.authenticatedUser.company_id == 12)) {
                console.log('Company ID ' + $scope.authenticatedUser.company_id + ' - Kullanıcı station_id:', $scope.authenticatedUser.station_id);
                
                // Eğer kullanıcının station_id'si varsa direkt ata
                if ($scope.authenticatedUser.station_id) {
                    $timeout(function() {
                        $scope.newOrderData.exit_station_id = parseInt($scope.authenticatedUser.station_id);
                        console.log('✅ Kullanıcının şubesi otomatik seçildi - Station ID:', $scope.newOrderData.exit_station_id);
                        refreshPickers(); // Arayüzü güncelle
                    }, 200);
                } else {
                    // Station_id yoksa filterStations'dan bul
                    console.log('Kullanıcının station_id yok, filterStations watch başlatıldı');
                    $scope.$watch(function() {
                        return $rootScope.filterStations;
                    }, function(newValue, oldValue) {
                        console.log('filterStations değişti:', newValue ? newValue.length : 'null', 'Mevcut exit_station_id:', $scope.newOrderData.exit_station_id);
                        if (newValue && newValue.length > 0 && !$scope.newOrderData.exit_station_id) {
                            console.log('Station arama yapılıyor...');
                            // Gaziantep Merkez Şube'yi varsayılan olarak seç
                            var gaziantepStation = newValue.find(function(station) {
                                var stationCode = station.code ? station.code.toLowerCase().replace(/\s+/g, ' ').trim() : '';
                                var hasGaziantep = stationCode.includes('gaziantep');
                                var hasMerkez = stationCode.includes('merkez');
                                console.log('Station kontrol:', station.code, 'Gaziantep:', hasGaziantep, 'Merkez:', hasMerkez);
                                return hasGaziantep && hasMerkez;
                            });
                            if (gaziantepStation) {
                                $timeout(function() {
                                    $scope.newOrderData.exit_station_id = gaziantepStation.id;
                                    console.log('✅ Varsayılan şube seçildi:', gaziantepStation.code, 'ID:', gaziantepStation.id, 'Tip:', typeof gaziantepStation.id);
                                    refreshPickers(); // Arayüzü güncelle
                                }, 200);
                            } else {
                                console.log('❌ Gaziantep Merkez Şube bulunamadı. Tüm stationlar:', newValue);
                            }
                        }
                    }, true);
                }
            }

            $scope.init = function () {
                // Mobile source ve Company ID 87 için müşteri listesi yükleme optimizasyonu
                var params = {};
                if ($scope.newOrderData && $scope.newOrderData.source === 'mobile') {
                    params.load_customers = 'false';
                } else if ($scope.authenticatedUser && ($scope.authenticatedUser.company_id == 87 || $scope.authenticatedUser.company_id == 12)) {
                    // Company ID 87 ve 12 için autocomplete kullandığımız için müşteri listesi yükleme
                    params.load_customers = 'false';
                }
                
                console.log('NewOrder init - params:', params);
                console.log('NewOrder init - company_id:', $scope.authenticatedUser ? $scope.authenticatedUser.company_id : 'undefined');
                
                Order.newOrderData(params).success(function (data) {
                    console.log('NewOrder response - customers count:', data.customers ? data.customers.length : 'undefined');
                    console.log('NewOrder response - customers:', data.customers);
                    $scope.orderData = data;
                    // Mevcut company_customer_id ve exit_station_id'yi sakla
                    var currentCustomerId = $scope.newOrderData.company_customer_id;
                    var currentExitStationId = $scope.newOrderData.exit_station_id;
                    
                    // Yıkıcı sıfırlama yerine sadece varsayılanları ata
                    $scope.newOrderData.type = 1;
                    $scope.newOrderData.scheduled_time = '';
                    $scope.newOrderData.send_sms_sender = true;
                    $scope.newOrderData.send_sms_receiver = true;
                    $scope.newOrderData.print_barcode = true;
                    $scope.newOrderData.status = 2;
                    $scope.newOrderData.order_payment = 'offline';
                    $scope.newOrderData.receiver_type = 'corporate';
                    $scope.newOrderData.flexible_date = 0;
                    $scope.newOrderData.collection_amount = 0;
                    if (!$scope.newOrderData.items || $scope.newOrderData.items.length === 0) {
                        $scope.newOrderData.items = [{ weight: null }];
                    }
                    if (!$scope.newOrderData.location) {
                        $scope.newOrderData.location = { receiver_type: 'corporate' };
                    }
                    
                    // Company ID 87 ve 12 olan kullanıcılar için Standart Teslimat varsayılan olsun
                    if ($scope.authenticatedUser && ($scope.authenticatedUser.company_id == 87 || $scope.authenticatedUser.company_id == 12)) {
                        // Standart Teslimat work_type'ını bul
                        var standardDelivery = $scope.orderData.workTypes.find(function(workType) {
                            return workType.name && workType.name.toLowerCase().includes('standart');
                        });
                        if (standardDelivery) {
                            $scope.newOrderData.work_type = standardDelivery.id;
                        } else {
                             $scope.newOrderData.work_type = $scope.orderData.workTypes[0].id;
                        }
                        
                        // Önceden ayarlanmış exit_station_id'yi (watch'tan gelen) koru
                        if (currentExitStationId) {
                            $scope.newOrderData.exit_station_id = currentExitStationId;
                            console.log('🔄 Exit Station ID geri yüklendi:', currentExitStationId);
                        }
                    } else {
                         $scope.newOrderData.work_type = $scope.orderData.workTypes[0].id;
                    }
                    
                    // Eğer önceden seçili bir müşteri varsa, onu tekrar ata
                    if (currentCustomerId) {
                        $scope.newOrderData.company_customer_id = currentCustomerId;
                    }
                    
                    // Tüm model güncellemelerinden sonra arayüzü senkronize et
                    refreshPickers();
                    
                    // Not: station_id ve work_type zaten yukarıda doğru şekilde ayarlandı
                    // Tekrar ezmeye gerek yok
                    // Company ID 87 için harita yükleme optimizasyonu (harita gösterilmez)
                    // Company ID 12 için harita gösterilir
                    if ($scope.authenticatedUser && $scope.authenticatedUser.company_id != 87) {
                        createMapCustomer();
                    }
                    if ($routeParams.order_id) {
                        $scope.isInitialOrderLoad = true;
                        Order.order($routeParams.order_id).success(function (data, status, headers, config) {
                            var originalNeighbourhood = data.order.location.neighbourhood; // Değeri koru
                            $scope.newOrderData = data.order
                            try {
                                var city = $scope.orderData.cities.find(i => i.city.name == data.order.location.city);
                                $scope.newOrderData.location.city_id = JSON.stringify(city);
                                if (city) {
                                    var district = city.districts.find(i => i.district == data.order.location.district);
                                    if (district) {
                                        $scope.setDistricts()
                                        $scope.newOrderData.location.state_id = JSON.stringify(district);
                                        
                                        // Angular'ın listeyi güncellemesini bekleyip doğru değeri ata
                                        $timeout(function() {
                                            $scope.newOrderData.location.neighbourhood = originalNeighbourhood;
                                        }, 100); // 0ms'den 100ms'ye çıkarıldı, render garantisi için
                                    }
                                }
                            } catch (error) {

                            }

                            $timeout(function() {
                                console.log(123);
                                $('.selectpicker').selectpicker('refresh');
                            }, 200);
                            $scope.newOrderData.work_type = data.order.work_type ? data.order.work_type.id : $scope.orderData.workTypes[0].id;
                            
                            // Company ID 87 ve 12 olan kullanıcılar için Standart Teslimat varsayılan olsun (sipariş düzenleme durumunda)
                            if ($scope.authenticatedUser && ($scope.authenticatedUser.company_id == 87 || $scope.authenticatedUser.company_id == 12) && !data.order.work_type) {
                                var standardDelivery = $scope.orderData.workTypes.find(function(workType) {
                                    return workType.name && workType.name.toLowerCase().includes('standart');
                                });
                                if (standardDelivery) {
                                    $scope.newOrderData.work_type = standardDelivery.id;
                                }
                            }
                            
                            // Tahsilat tutarı yoksa 0 olarak ayarla
                            if (!$scope.newOrderData.collection_amount) {
                                $scope.newOrderData.collection_amount = 0;
                            }
                            
                            if ($scope.newOrderData && $scope.newOrderData.location && $scope.newOrderData.location.receiver_type == 'individual') {
                                $scope.newOrderData.address = data.order.customer;
                            }
                            $scope.locationSelectedCustomer(data.order.location, 'order')
                            if($scope.authenticatedUser.station_neighbourhoods) {
                                $scope.newOrderData.work_type = 56;
                            }
                        });
                    }
                });
            }

            $scope.submitNewOrder = function () {
                if (!$scope.newOrderData.location.name) {
                    $('.location-name input').focus();
                } else {
                    setTimeout(() => {
                        document.getElementById('newWorkBtn').click()
                    }, 300);
                }
            }

            $scope.addBox = function () {
                // Düzenlemede newOrderData tamamen sunucu yanıtıyla değiştiriliyor; paketi
                // olmayan işlerde items alanı hiç gelmeyebiliyor.
                if (!$scope.newOrderData.items) {
                    $scope.newOrderData.items = [];
                }
                $scope.newOrderData.items.push({
                    weight: null,
                });
            }

            $scope.removeBox = function (index) {
                $scope.newOrderData.items.splice(index, 1);
            }

            $scope.testRoute = function (index) {
                $location.path('/orders').search('real_order', true);
            }
            
            $scope.newOrder = function (newWork, valid) {
                if (newWork) {
                    $scope.disabledBtn = true;
                    if ($scope.newOrderData.receiver_type && $scope.newOrderData.receiver_type == 'individual') {
                        $scope.newOrderData.address.customer_type = 'individual';
                    }
                    // Tahsilat tutarı yoksa veya boşsa 0 olarak ayarla
                    if (!$scope.newOrderData.collection_amount || $scope.newOrderData.collection_amount === '') {
                        $scope.newOrderData.collection_amount = 0;
                    }
                    Order.newOrder($scope.newOrderData).success(function (data, status, headers, config) {
                        if ($scope.authenticatedUser.station_neighbourhoods) {
                            // Asenkron barkod yazdırma - YENİ optimize edilmiş endpoint kullanılıyor
                            if ($scope.newOrderData.print_barcode) {
                                Messenger().post('Barkod yazdırılıyor...', 'info');
                                setTimeout(() => {
                                    $scope.printFastBarcodeOrder(data.id[0]);
                                }, 100);
                            }
                            // Hemen yönlendir
                            setTimeout(() => {
                                $location.path('/orders');
                            }, 400);

                        }
                        $scope.newOrderData = {
                            type: 1,
                            address: {},
                            scheduled_time: '',
                            status: 2,
                            location: {
                                receiver_type: 'corporate'
                            },
                            order_payment: 'offline',
                            receiver_type: 'corporate',
                            flexible_date: 0,
                            collection_amount: 0,
                            items: [{
                                weight: null,
                            }]
                        };
                        $scope.disabledBtn = false;
                        $('#successBox').modal('show');
                        // $scope.getOrderDetails(data);
                    }).error(function (data) {
                        Messenger().post({ message: data.message, type: "error" });
                        $scope.disabledBtn = false;
                    });
                }
            }

            $scope.setDistricts = function () {
                try {
                    var cityId = JSON.parse($scope.newOrderData.location.city_id);
                    var districs = $scope.orderData.cities.find(function (city) {
                        return city.city.id == cityId.city.id;
                    });
                    $scope.orderData.districts = districs.districts;
                    $scope.newOrderData.location.city = cityId.city.name;
                } catch (error) {

                }
            }

            $scope.setNeighbourhoods = function () {
                var neighbourhoods = JSON.parse($scope.newOrderData.location.state_id);
                $scope.orderData.neighbourhoods = neighbourhoods.neighbourhoods;
                $scope.newOrderData.location.state = neighbourhoods.district; // İlçe
                $scope.newOrderData.location.district = neighbourhoods.district; // İlçe (aynı değer)
            }

            $scope.updateOrder = function (newWork) {
                $scope.disabledBtn = true;
                // Tahsilat tutarı yoksa veya boşsa 0 olarak ayarla
                if (!$scope.newOrderData.collection_amount || $scope.newOrderData.collection_amount === '') {
                    $scope.newOrderData.collection_amount = 0;
                }
                Order.updateOrder($scope.newOrderData).success(function (data, status, headers, config) {
                    Messenger().post('Başarıyla Güncellendi!');
                    $scope.disabledBtn = false;
                    $scope.getOrderDetails($scope.newOrderData);
                    $rootScope.procces = 'update';
                    $('#successBox').modal('show');
                    if ($scope.authenticatedUser.station_neighbourhoods) {
                        if (data.print_barcode) {
                            $scope.printFastBarcodeOrder(data.id)
                        }
                        setTimeout(() => {
                            $location.path('/orders').search('real_order', true);
                        }, 400);
                    }
                    
                    $scope.newOrderData = {
                        type: 1,
                        address: {},
                        scheduled_time: '',
                        send_sms_sender: true,
                        send_sms_receiver: true,
                        print_barcode: true,
                        status: 2,
                        location: {
                            receiver_type: 'corporate'
                        },
                        order_payment: 'offline',
                        receiver_type: 'corporate',
                        flexible_date: 0,
                        collection_amount: 0,
                        items: [{
                            weight: null,
                        }]
                    };
                }).error(function (data) {
                    $scope.disabledBtn = false;
                    Messenger().post({ message: data.message, type: "error" });
                });
            };

            $scope.isLocationSelecting = false;

            $scope.locationSelectedCustomerIndividual = function (selected, type) {
                var customer;
                if (typeof type === 'undefined') {
                    customer = typeof selected !== 'undefined' ? selected.originalObject : [];
                } else {
                    customer = selected;
                }

                if (typeof customer !== 'undefined' && typeof customer.latitude !== 'undefined') {
                    angular.merge($scope.newOrderData.address, customer);
                    $scope.newOrderData.address.city = customer.city;
                    $scope.newOrderData.address.state = customer.state;
                    $scope.newOrderData.address.district = customer.district; // İlçe
                    $scope.newOrderData.address.neighbourhood = customer.neighbourhood; // Mahalle
                    $scope.newOrderData.address.identity_number = customer.identity_number;
                    $scope.newOrderData.address.vkn_number = customer.vkn_number;

                    console.log(customer)
                    console.log($scope.newOrderData.address)

                    if (type && type == 'search') {
                        var address = '';
                        if (customer.street) {
                            address += customer.street + ' ';
                        }
                        if (customer.number) {
                            address += 'No:' + customer.number + ' ';
                        }
                        $scope.newOrderData.address.address = address;
                    } else {
                        $scope.newOrderData.address.address = customer.address;
                    }

                    $scope.newOrderData.address.zipcode = customer.zipcode ? customer.zipcode : customer.zip;

                    $scope.states.forEach(element => {
                        if (element.abbreviation == customer.city) {
                            $scope.newOrderData.address.state = element.name;
                            return true;
                        }
                    });
                }
            }

            $scope.locationSelectedCustomer = function (selected, type) {
                try {
                    selected.receiver_type = $scope.newOrderData.location.receiver_type;
                    selected.originalObject.receiver_type = $scope.newOrderData.location.receiver_type;
                } catch (error) {

                }
                var customer;
                if (typeof type === 'undefined') {
                    customer = typeof selected !== 'undefined' ? selected.originalObject : [];
                } else {
                    customer = selected;
                }

                if (typeof customer !== 'undefined' && typeof customer.latitude !== 'undefined') {
                    // Flag'i true yap
                    $scope.isLocationSelecting = true;

                    // Telefon numarası alanından çağrıldıysa, ng-model'e yazılan değeri düzelt
                    // angucomplete-alt bileşeni title-field'ı ng-model'e yazıyor, bu yüzden düzeltmemiz gerekiyor
                    if ($scope.newOrderData.location.phone_number && 
                        typeof $scope.newOrderData.location.phone_number === 'string' && 
                        $scope.newOrderData.location.phone_number.includes(customer.name)) {
                        // Eğer telefon numarası alanında name,address,phone_number birleşimi varsa, sadece phone_number'ı al
                        $scope.newOrderData.location.phone_number = customer.phone_number;
                    }

                    // Company ID 87 ve 12 için harita yoksa direkt form doldur
                    if ($scope.authenticatedUser && ($scope.authenticatedUser.company_id == 87 || $scope.authenticatedUser.company_id == 12)) {
                        // Harita olmadan direkt form doldur
                        // Önce mevcut telefon numarasını koru (eğer doğruysa)
                        var currentPhone = $scope.newOrderData.location.phone_number;
                        angular.merge($scope.newOrderData.location, customer);
                        // Telefon numarasını doğru şekilde ayarla
                        $scope.newOrderData.location.phone_number = customer.phone_number || currentPhone;
                        $scope.newOrderData.location.name = customer.name;
                        $scope.newOrderData.location.city = customer.city;
                        $scope.newOrderData.location.state = customer.district; // İlçe
                        $scope.newOrderData.location.district = customer.district; // İlçe (aynı değer)
                        $scope.newOrderData.location.neighbourhood = customer.neighbourhood; // Mahalle
                        $scope.newOrderData.location.email = customer.email;

                        if (type && type == 'search') {
                            var address = '';
                            if (customer.street) {
                                address += customer.street + ' ';
                            }
                            if (customer.number) {
                                address += 'No:' + customer.number + ' ';
                            }
                            $scope.newOrderData.location.address = address;
                        } else {
                            $scope.newOrderData.location.address = customer.address;
                        }

                        $scope.newOrderData.location.zipcode = customer.zipcode ? customer.zipcode : customer.zip;

                        $scope.states.forEach(element => {
                            if (element.abbreviation == customer.city) {
                                $scope.newOrderData.location.state = element.name;
                                return true;
                            }
                        });

                        try {
                            var city = $scope.orderData.cities.find(i => i.city.name == $scope.newOrderData.location.city);
                            $scope.newOrderData.location.city_id = JSON.stringify(city);
                            if (city) {
                                $scope.setDistricts()
                                // İlçe araması için state alanını kullan (çünkü district artık mahalle)
                                var district = city.districts.find(i => i.district == $scope.newOrderData.location.state);
                                if (district) {
                                    $scope.newOrderData.location.state_id = JSON.stringify(district);
                                    $scope.setNeighbourhoods()
                                    var neighbourhood = district.neighbourhoods.find(i => i.name == $scope.newOrderData.location.neighbourhood);
                                    if (neighbourhood) {
                                        $scope.newOrderData.location.neighbourhood = neighbourhood.name
                                    }
                                }
                            }
                        } catch (error) {

                        }

                        // İşlem bittikten sonra flag'i false yap
                        setTimeout(function () {
                            $scope.isLocationSelecting = false;
                            $scope.isInitialOrderLoad = false;
                            $scope.$apply();
                        }, 100);
                    } else {
                        // Normal harita ile çalışma
                        var location = [customer.longitude, customer.latitude];
                        var location = [Number(customer.latitude), Number(customer.longitude)];

                        $scope.searchMap.panTo(location, {
                            duration: 300,
                            timingFunction: 'ease-in-out'
                        }).then(function () {
                        // Önce mevcut telefon numarasını koru (eğer doğruysa)
                        var currentPhone = $scope.newOrderData.location.phone_number;
                        angular.merge($scope.newOrderData.location, customer);
                        // Telefon numarasını doğru şekilde ayarla
                        $scope.newOrderData.location.phone_number = customer.phone_number || currentPhone;
                        $scope.newOrderData.location.name = customer.name;
                        $scope.newOrderData.location.city = customer.city;
                        $scope.newOrderData.location.state = customer.district; // İlçe
                        $scope.newOrderData.location.district = customer.district; // İlçe (aynı değer)
                        $scope.newOrderData.location.neighbourhood = customer.neighbourhood; // Mahalle
                        $scope.newOrderData.location.email = customer.email;

                        if (type && type == 'search') {
                            var address = '';
                            if (customer.street) {
                                address += customer.street + ' ';
                            }
                            if (customer.number) {
                                address += 'No:' + customer.number + ' ';
                            }
                            $scope.newOrderData.location.address = address;
                        } else {
                            $scope.newOrderData.location.address = customer.address;
                        }

                        $scope.newOrderData.location.zipcode = customer.zipcode ? customer.zipcode : customer.zip;

                        $scope.states.forEach(element => {
                            if (element.abbreviation == customer.city) {
                                $scope.newOrderData.location.state = element.name;
                                return true;
                            }
                        });

                        try {
                            var city = $scope.orderData.cities.find(i => i.city.name == $scope.newOrderData.location.city);
                            $scope.newOrderData.location.city_id = JSON.stringify(city);
                            if (city) {
                                $scope.setDistricts()
                                // İlçe araması için state alanını kullan (çünkü district artık mahalle)
                                var district = city.districts.find(i => i.district == $scope.newOrderData.location.state);
                                if (district) {
                                    $scope.newOrderData.location.state_id = JSON.stringify(district);
                                    $scope.setNeighbourhoods()
                                    var neighbourhood = district.neighbourhoods.find(i => i.name == $scope.newOrderData.location.neighbourhood);
                                    if (neighbourhood) {
                                        $scope.newOrderData.location.neighbourhood = neighbourhood.name
                                    }
                                }
                            }
                        } catch (error) {

                        }

                        // İşlem bittikten sonra flag'i false yap
                        setTimeout(function () {
                            $scope.isLocationSelecting = false;
                            $scope.isInitialOrderLoad = false;
                            $scope.$apply();
                        }, 100);
                        });
                    }
                }
            };

            $scope.handlePiece = function () {
                if ($scope.newOrderData.piece) {
                    $scope.newOrderData.items = [];
                    for (let index = 0; index < $scope.newOrderData.piece; index++) {
                        $scope.addBox();
                    }
                }
            }

            $scope.selectCustomerId = function (id) {
                $rootScope.company_customer_id = id;
                if ($scope.newOrderData.company_customer_id == 'add_new') {
                    $location.path('musteri-yonetimi').search('new', true);
                } else {
                    var find = $scope.orderData.customers.find(i => i.id == $rootScope.company_customer_id);
                    console.log(find);
                    $scope.newOrderData.customer_phone_number = find.phone_number;
                    $timeout(function() {
                        $('.selectpicker').selectpicker('refresh');
                    });
                }
            }

            // Company 87 için autocomplete müşteri arama
            var lastTypeNewOrder = '';
            // "Yeni Müşteri Ekle" seçeneğini başlangıçta ekle
            $scope.searchResNewOrder = [{
                id: 'add_new',
                customer_name: 'Yeni Müşteri Ekle',
                dba_name: ''
            }];
            
            $scope.searchCustomerForNewOrder = function ($select, type) {
                if (type != lastTypeNewOrder) {
                    $scope.searchResNewOrder = [{
                        id: 'add_new',
                        customer_name: 'Yeni Müşteri Ekle',
                        dba_name: ''
                    }];
                }
                
                if ($select.search && $select.search.length >= 2) {
                    return $http.get('api/find-customer', {
                        params: {
                            s: $select.search,
                            type: type
                        },
                        ignoreLoadingBar: true
                    }).then(function (response) {
                        // "Yeni müşteri ekle" seçeneğini listenin başına ekle
                        $scope.searchResNewOrder = [{
                            id: 'add_new',
                            customer_name: 'Yeni Müşteri Ekle',
                            dba_name: ''
                        }].concat(response.data.customers || []);
                    });
                    lastTypeNewOrder = type;
                }
            }

            // Autocomplete'ten müşteri seçildiğinde
            $scope.selectCustomerFromSearch = function () {
                if ($scope.newOrderData.customerSelected) {
                    if ($scope.newOrderData.customerSelected.id == 'add_new') {
                        // Yeni müşteri ekle sayfasına yönlendir
                        $location.path('musteri-yonetimi').search('new', true);
                    } else {
                        // Seçilen müşteriyi newOrderData'ya ata
                        $scope.newOrderData.company_customer_id = $scope.newOrderData.customerSelected.id;
                        $rootScope.company_customer_id = $scope.newOrderData.customerSelected.id;
                        $scope.newOrderData.customer_phone_number = $scope.newOrderData.customerSelected.phone_number;
                        console.log('Selected customer:', $scope.newOrderData.customerSelected);
                    }
                }
            }

            function createMapCustomer() {
                $scope.searchMap = new ymaps.Map('customerMapOrder', {
                    center: [Number($scope.authenticatedUser.location.lat), Number($scope.authenticatedUser.location.lon)],
                    zoom: 11,
                }, {
                    searchControlProvider: 'yandex#search'
                });

                var centerMarkerHtml = '<div class="center-marker" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 1000;">' +
                    '<img src="/img/map-pin-blue.png" style="width: 40px; height: 48px;">' +
                    '</div>';

                document.getElementById('customerMapOrder').insertAdjacentHTML('beforeend', centerMarkerHtml);

                // Harita hareketi bittiğinde merkez konumunu al
                $scope.searchMap.events.add('actionend', function () {
                    if ($scope.isLocationSelecting || $scope.isInitialOrderLoad) return;

                    var centerCoords = $scope.searchMap.getCenter();
                    ymaps.geocode(centerCoords).then(function (res) {
                        var firstGeoObject = res.geoObjects.get(0);
                        if (firstGeoObject) {
                            var address = firstGeoObject.getAddressLine();
                            var details = {
                                latitude: centerCoords[1],
                                longitude: centerCoords[0],
                                formatted: address
                            };

                            var addressComponents = firstGeoObject.properties.get('metaDataProperty.GeocoderMetaData.Address.Components');
                            addressComponents.forEach(function (component) {
                                switch (component.kind) {
                                    case 'locality':
                                        details.city = component.name;
                                        break;
                                    case "province":
                                        details.city = component.name;
                                        break;
                                    case 'area':
                                        details.district = component.name;
                                        break;
                                    case 'district':
                                        details.neighbourhood = component.name;
                                        break;
                                    case 'street':
                                        details.street = component.name;
                                        break;
                                    case 'house':
                                        details.number = component.name;
                                        break;
                                    case 'postal_code':
                                        details.zipcode = component.name;
                                        break;
                                }
                            });

                            console.log('details', details)
                            $scope.$apply(function () {
                                angular.merge($scope.newOrderData.location, details);
                                $scope.newOrderData.location.city = details.city;
                                $scope.newOrderData.location.state = details.district;
                                $scope.newOrderData.location.neighbourhood = details.neighbourhood;
                                $scope.newOrderData.location.district = details.district;
                                $scope.newOrderData.location.address = details.formatted
                                $scope.newOrderData.location.zipcode = details.zipcode;
                                console.log($scope.newOrderData)
                            });
                        }
                    });
                });

                if (navigator.geolocation && !$scope.newOrderData.id) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        var userLocation = [position.coords.latitude, position.coords.longitude];
                        $scope.searchMap.setCenter(userLocation);
                        $scope.$apply();
                    });
                }
            }
        }
    ]);